<form class="flex-layout auction-permissions h-auto" [formGroup]="auctionsForm">
  <h2>
    Auction Permissions
  </h2>
  <div class="row">
    <div class="col-md-3">
      View Auction Details
      <img src="/assets/images/JMicons/info_outline.png" width="20" id="view-auction-pl-info" [placement]="['bottom-left', 'bottom-right', 'right']" [ngbPopover]="auctionsPopup" #popover="ngbPopover">
    </div>
    <div class="col-md-3 pl-md-2">
      <mat-checkbox formControlName="allowed" (change)="onChange($event)">Allowed</mat-checkbox>
    </div>
  </div>
  <div class="row footer">
    <mat-card-actions align="end" class="col save-container">
      <button mat-raised-button color="primary" type="button" [disabled]="this.auctionsForm.pristine || !hasAllowChanged" (click)="onSubmit()">Save</button>
    </mat-card-actions>
  </div>
</form>
<hr class="pb-1rem"/>
<ng-template #auctionsPopup>
  <div class="row info-wrap popup-wrap" id="auctionsPopup">
    <div class="col-10 info-head font-weight-bold mb-1">
      Allowed must be selected for user to see Auction information.
    </div>
    <mat-icon class="col-2 close-wrap mb-1 text-right" width="12">close</mat-icon>
  </div>
</ng-template>